<script setup lang="ts">
import ModalWithButtons from '@/components/Modal/ModalWithButtons.vue'
import { useTeamPlanCheckout } from '@/hooks/usePayment'
import { useTeamStore } from '@/store/teamStore'
import PriceTable from './parts/PriceTable.vue'
const teamStore = useTeamStore()
const { currentTeam } = storeToRefs(teamStore)
const { buttonState, checkout } = useTeamPlanCheckout(
  currentTeam.value!.id,
  currentTeam.value!.approvedMembers.length,
  currentTeam.value!.plan.data.volumeDiscountPrice
)
const emits = defineEmits<{
  (e: 'compare'): void
  (e: 'close'): void
}>()
</script>

<template>
  <ModalWithButtons :title="'チームプランを継続する'" @close="emits('close')">
    <template #contents>
      <PriceTable />
    </template>
    <template #description>
      <description>無料トライアルが終了しました。</description>
      <div class="lo-v-end">
        <slot name="description" />
      </div>
    </template>
    <template #first-button>
      <div class="lo-v-start">
        <NitButton
          :width="'100%'"
          :button-state="buttonState"
          @click="checkout"
        >
          チームプランを継続する
        </NitButton>
        <sup-label class="gray-1 mg-top-4px">
          決済サービス<a href="https://stripe.com/jp">Stripe</a>に遷移します。
        </sup-label>
      </div>
    </template>
  </ModalWithButtons>
</template>
